import { writable } from "svelte/store";
export class Rose {
    constructor(id, src, videoSrc, artist, description) {
        this.id = id;
        this.src = src;
        this.videoSrc = videoSrc;
        this.artist = artist;
        this.description = description.trimEnd();
    }
}
export class PendingRose extends Rose {
    constructor(id, src, videoSrc, artist, description, queuePosition) {
        super(id, src, videoSrc, artist, description);
        this.queuePosition = queuePosition;
    }
}
export class Artist {
    constructor(id, name) {
        this.id = id;
        this.name = name;
    }
}
Artist.all = new Artist(0, 'Tots');
export const roses = writable([]);
export const artists = writable([]);
export const artistsWithRose = writable([]);
export const loaded = writable(false);
class RoseService {
    constructor() {
        this.storageURL = 'https://storage.googleapis.com/roses-inlab-fib';
        this.fetchData();
    }
    async createRose(artist, description, email) {
        let cleanDescription = ['.', ',', '?', '!', '¿', '¡'].some(e => description.endsWith(e)) ? description + '-' : description;
        let formBody = `type=pintors&artist=${encodeURIComponent(artist)}&words=${encodeURIComponent(cleanDescription)}&email=${encodeURIComponent(email)}`;
        try {
            const response = await fetch('/api/donam_rosa', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const json = await response.json();
            return {
                error: json['on_queue'] < 0,
                message: json['url']
            };
        }
        catch (e) {
            return {
                error: true,
                message: "Hi ha hagut un error a l'enviar la teva sol·licitud. Torna-ho a provar més tard"
            };
        }
    }
    async fetchData() {
        const requestRoses = fetch('https://storage.googleapis.com/roses-inlab-fib/roses.json');
        const responseArtists = await fetch('/2022/artistes.json');
        const jsonArtists = await responseArtists.json();
        const newArtists = jsonArtists.map(art => new Artist(art['id'], art['nom']));
        const responseRoses = await requestRoses;
        const json_response = await responseRoses.json();
        const newRoses = json_response.map(rjs => new Rose(rjs['id'], this.getStorageUrlFromRoseId(rjs['id']), this.getStorageVideoUrlFromRoseId(rjs['id']), rjs['artist'], this.getDescriptionFromRoseId(rjs['id'])));
        roses.set(newRoses);
        artists.set(newArtists);
        artistsWithRose.set(newArtists.filter(a => newRoses.some((r) => r.artist == a.name)));
        loaded.set(true);
    }
    getStorageUrlFromRoseId(roseId) {
        return `${this.storageURL}/pintors/${roseId}.png`;
    }
    getStorageVideoUrlFromRoseId(roseId) {
        return `${this.storageURL}/pintors/${roseId}.mp4`;
    }
    getAuthorFromRoseId(roseId) {
        return roseId.split('_')[0].replace(/-/g, ' ');
    }
    getDescriptionFromRoseId(roseId) {
        return roseId.split('_')[1].replace(/-/g, ' ');
    }
    async checkIfRoseExists(roseId) {
        const roseSource = this.getStorageUrlFromRoseId(roseId);
        const response = await fetch(roseSource, { mode: 'cors' });
        return response.status >= 200 && response.status < 300;
    }
    async checkRoseQueuePosition(roseId) {
        const response = await fetch(`/api/get_query_position?rose_id=${roseId}.png`, { method: 'post' });
        const body = await response.json();
        return body['on_queue'];
    }
    async getRoseNotInJSON(roseId) {
        let rose = null;
        const exists = await roseService.checkIfRoseExists(roseId);
        if (exists) {
            // 1r cas: La rosa existeix, però encara no està al JSON perquè no està actualitzat
            const src = roseService.getStorageUrlFromRoseId(roseId);
            const videoSrc = roseService.getStorageVideoUrlFromRoseId(roseId);
            const artist = roseService.getAuthorFromRoseId(roseId);
            const description = roseService.getDescriptionFromRoseId(roseId);
            rose = new Rose(roseId, src, videoSrc, artist, description);
        }
        else {
            // 2n cas, la rosa s'està generant
            const queue = await this.checkRoseQueuePosition(roseId);
            if (queue > 0) {
                const src = roseService.getStorageUrlFromRoseId(roseId);
                const videoSrc = roseService.getStorageVideoUrlFromRoseId(roseId);
                const artist = roseService.getAuthorFromRoseId(roseId);
                const description = roseService.getDescriptionFromRoseId(roseId);
                rose = new PendingRose(roseId, src, videoSrc, artist, description, queue);
            }
        }
        return rose;
    }
}
export const roseService = new RoseService();
